import React from 'react'
import { AdOrderContext } from '../contexts/AdOrder'

export default function useGoToPayment () {

  const { adOrder, setAdOrder, restUrl, isLoading, setIsLoading } = React.useContext(AdOrderContext)

  const submit = function (onError, onSuccess) {
    setIsLoading(true)
    let wasSuccessful = false

    fetch(restUrl + adOrder.token, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ order: adOrder })
      }
    )
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then(response => {
        if (response?.success === true) {
          if (response.data?.replaceOrder) {
            let order = response.data.order
            order.contact = response.data.contact
            order.payment = response.data.payment
            setAdOrder(order)
          }

          wasSuccessful = true

          if (response.data?.newLocation) {
            window.location = response.data.newLocation
          }
        } else {
          throw new Error(response?.message || 'Submission failed')
        }
      })
      .catch((error) => {
        console.error('Update Order Error:', error)

        let errorMessage
        if (error.message.includes('404')) {
          errorMessage = 'Ordren blev ikke fundet. Prøv at genindlæse siden.'
        } else if (error.message.includes('500')) {
          errorMessage = 'Der opstod en serverfejl. Prøv igen senere.'
        } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
          errorMessage = 'Ingen forbindelse til serveren. Tjek din internetforbindelse.'
        } else {
          errorMessage = 'Der opstod en fejl ved indsendelse af ordren. Prøv igen.'
        }

        if (onError) {
          onError(errorMessage)
        }
      })
      .finally(() => {
        setIsLoading(false)

        if (wasSuccessful && onSuccess) {
          onSuccess()
        }
      })
  }

  return {
    submit,
    isLoading
  }
}